import find from 'lodash/find';
import { OPTIONS } from '../../constants';

export const getCurrentFilterLabel = (value: string) => {
  const optionLabel = (find(OPTIONS, { value }) || {}).label;
  return optionLabel ? `${optionLabel} bookings` : '';
};
